import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const CommonClass = twMerge([
  'block',
  'w-full',
  'p-2.5',
  'text-sm',
  'border',
  'rounded-lg',
  'font-normal'
]);

export const textInputVariant = cva(CommonClass, {
  variants: {
    variant: {
      primary:
        'bg-white border-aux-gray text-aux-gray-2 focus:ring-0 focus:border-emerge-teal focus:text-emerge-navy',
      error:
        'bg-emerge-orange-3 text-error-darkred border-error-darkred focus:ring-0 focus:border-error-darkred'
    }
  },
  defaultVariants: {
    variant: 'primary'
  }
});
